import { z } from 'zod'
 
export const LoginFormSchema = z.object({
  email: z
    .string()
    .refine((val) => !/^\s|\s$/.test(val), {
      message: 'Email address cannot have leading or trailing spaces',
    })
    .refine((val) => !/\s/.test(val), {
      message: 'Email address cannot contain spaces',
    })
    .pipe(z.string().email('Please enter a valid email address')),
  password: z
    .string()
    .min(1, 'Password is required')
})
 
export type FormState =
  | {
      errors?: {
        email?: string[]
        password?: string[]
      }
      message?: string
    }
  | undefined